export const navbarText = {
  en: {
    nav: [
      { href: "#home", label: "Home" },
      { href: "#whyUs", label: "Why Us" },
      { href: "#process", label: "Our Process" },
      { href: "#services", label: "Services" },
      { href: "/blog", label: "Blog" },
    ],
    cta: "Contact Us",
    mobileCTA: "Let's Talk",
  },
  es: {
    nav: [
      { href: "#home", label: "Inicio" },
      { href: "#whyUs", label: "Por qué nosotros" },
      { href: "#process", label: "Nuestro proceso" },
      { href: "#services", label: "Servicios" },
      { href: "/blog", label: "Blog" },
    ],
    cta: "Contáctanos",
    mobileCTA: "Hablemos",
  },
  ja: {
    nav: [
      { href: "#home", label: "ホーム" },
      { href: "#whyUs", label: "私たちについて" },
      { href: "#process", label: "プロセス" },
      { href: "#services", label: "サービス" },
      { href: "/blog", label: "ブログ" },
    ],
    cta: "お問い合わせ",
    mobileCTA: "話しましょう",
  },
};
